<template>
  <BaseListCard
    title="Specific Terms - Building/Activity Areas"
    entityTitle="Building/Activity Areas"
    :parentId="instrumentId"
    :parentTitle="'Instrument'"
    :options="{ typeOptions, typeOptionsLoading }"
    :entities="entities"
    :entitiesLoading="entitiesLoading"
    :deleteEntity="deleteEntity"
    :emptyEntity="emptyEntity"
    :entitySort="entitySort"
    ref="baseCard"
  >
    <template v-slot:addForm="{ newEntity, options, stopAdding, entityCreated }">
      <BuildingActivityAreaForm
          :buildingActivityArea="newEntity"
          :typeOptions="options.typeOptions"
          :typeOptionsLoading="options.typeOptionsLoading"
          @entityCreated="entityCreated"
          @closeForm="stopAdding"
      >
      </BuildingActivityAreaForm>
    </template>
    <template v-slot:editForm="{ entity, options, stopEditing, entityUpdated }">
      <BuildingActivityAreaForm
          :buildingActivityArea="entity"
          :typeOptions="options.typeOptions"
          :typeOptionsLoading="options.typeOptionsLoading"
          @entityUpdated="entityUpdated"
          @closeForm="stopEditing"
      >
      </BuildingActivityAreaForm>
    </template>
    <template v-slot:entityDetails=" { entity }">
      <div class="row mb-2">
        <div class="col-sm-3">
          <div class="list-header">
            Special Condition Area ID
          </div>
          <div class="list-details">
            {{ entity.globalId }}
          </div>
        </div>
        <div class="col-sm-3">
          <div class="list-header">
            Type
          </div>
          <div class="list-details">
            {{ getTypeName(entity.typeId) }}
          </div>
        </div>
        <div class="col-sm-6">
          <div class="list-header">
            Notes
          </div>
          <div class="list-details  notes-field">{{getBuildingNotes(entity)}}</div>
        </div>
      </div>
    </template>
  </BaseListCard>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import BaseListCard from '../common/BaseListCard.vue';
import BuildingActivityAreaForm from './BuildingActivityAreaForm.vue';
import CollapseParent from '@/mixins/CollapseParent';
import { EntityModules, LookupModules } from '@/store/moduleConfig';

export default {
  name: 'BuildingActivityAreaCard',
  props: [
    'instrumentId',
  ],
  mixins: [CollapseParent],
  components: {
    BaseListCard,
    BuildingActivityAreaForm,
  },
  created() {
    this.$store.dispatch(`${LookupModules.BUILDING_ACTIVITY_AREA_TYPES.namespace}/fetchOptions`,
      LookupModules.BUILDING_ACTIVITY_AREA_TYPES.url);
  },
  computed: {
    ...mapState(LookupModules.BUILDING_ACTIVITY_AREA_TYPES.namespace, {
      typeOptionsLoading: state => state.loading,
    }),
    ...mapState(EntityModules.BUILDING_ACTIVITY_AREA.namespace, {
      entities: state => state.entities,
      entitiesLoading: state => state.loading,
    }),
    ...mapGetters(LookupModules.BUILDING_ACTIVITY_AREA_TYPES.namespace, {
      getTypeName: 'getName',
      typeOptions: 'getActiveOptions',
    }),
  },
  methods: {
    entitySort(a, b) {
      return b.id - a.id;
    },
    getBuildingNotes(entity) {
      if (!entity.notes || entity.notes === '') {
        return 'None';
      }
      return entity.notes;
    },
    emptyEntity(instrumentId) {
      return {
        instrumentId,
        typeId: '',
        notes: null,
      };
    },
    deleteEntity(entity) {
      this.$store.dispatch(
        `${EntityModules.BUILDING_ACTIVITY_AREA.namespace}/deleteEntity`, {
          entityType: EntityModules.BUILDING_ACTIVITY_AREA.namespace,
          entity,
        },
      );
    },
  },
};
</script>
